import { render, staticRenderFns } from "./EditLists.vue?vue&type=template&id=bbf6e306&scoped=true&"
import script from "./EditLists.vue?vue&type=script&lang=js&"
export * from "./EditLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf6e306",
  null
  
)

export default component.exports